import { Table } from "antd";
import { useEffect } from "react";

interface CommonTableProps {
  columns: any[];
  dataSource: any[];
  loading: boolean;
  pagination?: any;
  scroll?: any;
  className?: string;
  onChange?: (pagination: any, filters: any, sorter: any, extra: any) => void;
}

const tableStyles = `
.common-table-row {
  animation: fadeInRow 0.6s;
  transition: background 0.2s, box-shadow 0.25s;
}
.common-table-row:nth-child(even) {
  background: #fff;
}
.common-table-row:nth-child(odd) {
  background: #fff;
}
.common-table-row:hover {
  background: #e6f7ff !important;
  box-shadow: 0 8px 32px 0 rgba(24, 144, 255, 0.15), 0 2px 8px 0 rgba(0,0,0,0.06);
  z-index: 2;
  position: relative;
  transform: translateY(-2px) scale(1.01);
}
.ant-table-thead > tr > th {
  background: #e6f7ff !important;
  color: #00274c !important;
  font-weight: 700;
  font-size: 15px;
}
@keyframes fadeInRow {
  from { opacity: 0; transform: translateY(10px);}
  to { opacity: 1; transform: translateY(0);}
}
`;

export default function CommonTable({
  columns,
  dataSource,
  loading,
  pagination,
  scroll,
  className,
  onChange,
}: CommonTableProps) {
  useEffect(() => {
    if (!document.getElementById("common-table-animation-style")) {
      const style = document.createElement("style");
      style.id = "common-table-animation-style";
      style.innerHTML = tableStyles;
      document.head.appendChild(style);
    }
  }, []);
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={pagination}
      scroll={scroll}
      className={className}
      rowClassName={() => "common-table-row"}
      onChange={onChange}
    />
  );
}
